import { render } from "./FridgeDoorMonitorWeekly.vue?vue&type=template&id=390c57a7&scoped=true&ts=true"
import script from "./FridgeDoorMonitorWeekly.vue?vue&type=script&lang=ts"
export * from "./FridgeDoorMonitorWeekly.vue?vue&type=script&lang=ts"

import "./FridgeDoorMonitorWeekly.vue?vue&type=style&index=0&id=390c57a7&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390c57a7"]])

export default __exports__